exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html,\nbody,\n.index_app_3Qs6X {\n    position: relative;\n    /* probably unecessary, transitional until layout is refactored */\n    width: 100%;\n    height: 100%;\n    margin: 0;\n\n    /* Setting min height/width makes the UI scroll below those sizes */\n    /* min-width: 1360px; */\n    /* min-width: 1124px; */\n    overflow-x: auto;\n    /* min-height: 750px; Min height to fit sprite/backdrop button */\n    /* -webkit-overflow-scrolling: touch; */\n}\n\n/* @todo: move globally? Safe / side FX, for blocks particularly? */\n\n* { -webkit-box-sizing: border-box; box-sizing: border-box; }\n\n/* html,\nbody{\n    position: fixed;\n} */\n", ""]);

// exports
exports.locals = {
	"app": "index_app_3Qs6X"
};